<template>
  <div
    class="message-form-toggle d-flex justify-end"
    :class="{
      'message-form-toggle--radial-pulsating-animation': showAnimation
    }"
  >
    <div class="message-form-toggle__wrapper">
      <pp-button
        class="message-form-toggle__wrapper__btn pa-7 white--text text-h2"
        :icon="showForm ? 'chevron-down' : 'chat'"
        type="primary"
        @click="renderForm"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'ChatButton',
  props: {},
  data () {
    return {
      showForm: false,
      showAnimation: true
    }
  },
  methods: {
    renderForm () {
      this.showForm = !this.showForm
      this.showAnimation = false
      this.$emit('closeDialogChatEvent')
      sessionStorage.setItem('dialogClicked', true)
      this.trackShowHideForm()
    },
    closeForm () {
      this.showForm = false
    },
    trackShowHideForm () {
      this.trackGA({
        action: 'chat-button',
        label: this.showForm ? 'Show Form' : 'Hide Form'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .message-form-toggle {
    &__wrapper {
      padding: 2px;
      z-index: 100;
    }

    &--radial-pulsating-animation {
      &:before,
      &:after {
        animation: scaleIn 2.5s infinite cubic-bezier(0, 0, 0, 0);
        background-color: var(--pp-theme-color);
        border-radius: 50%;
        content: '';
        height: 60px;
        opacity: 0;
        position: absolute;
        width: 60px;
      }

      &:before {
        animation-delay: 1.5s;
      }

      &:after {
        animation-delay: 2s;
      }
    }
  }

  @keyframes scaleIn {
    from {
      opacity: .6;
      transform: scale(.8, .8);
    }

    to {
      opacity: 0;
      transform: scale(1.5, 1.5);
    }
  }
</style>
